import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Form, Button, Alert, Col, Row } from 'react-bootstrap';
import './AddProvider.scss';

const AddProvider = () => {
  const [providerName, setProviderName] = useState('');
  const [providerTypeId, setProviderTypeId] = useState('');
  const [providerScac, setProviderScac] = useState('');
  const [providerTypes, setProviderTypes] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProviderTypes = async () => {
      try {
        const response = await axios.get('/api/provider_types');
        setProviderTypes(response.data);
      } catch (error) {
        console.error('Error fetching provider types', error);
      }
    };
    fetchProviderTypes();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/provider', {
        provider_name: providerName,
        provider_type_id: providerTypeId,
        provider_scac: providerScac,
      });
      navigate('/providers', { state: { successMessage: 'Provider successfully created' } });
    } catch (error) {
      console.error('Error creating provider', error);
      setErrorMessage('Error: Unable to create new provider');
    }
  };

  return (
    <div className="add-provider">
      <h2>Add Provider</h2>
      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group as={Row} className="form-row">
          <Form.Label column sm={4}>Provider Name</Form.Label>
          <Col sm={8}>
            <Form.Control
              type="text"
              value={providerName}
              onChange={(e) => setProviderName(e.target.value)}
              required
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="form-row">
          <Form.Label column sm={4}>Provider Type</Form.Label>
          <Col sm={8}>
            <Form.Control
              as="select"
              value={providerTypeId}
              onChange={(e) => setProviderTypeId(e.target.value)}
              required
            >
              <option value="">Select a provider type</option>
              {providerTypes.map((type) => (
                <option key={type.provider_type_id} value={type.provider_type_id}>
                  {type.provider_type_name}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="form-row">
          <Form.Label column sm={4}>Provider SCAC</Form.Label>
          <Col sm={8}>
            <Form.Control
              type="text"
              value={providerScac}
              onChange={(e) => setProviderScac(e.target.value)}
              required
            />
            <Form.Text className="text-muted">
              A four-letter agent code or carrier alpha code (SCAC).
            </Form.Text>
          </Col>
        </Form.Group>
        <Button variant="primary" type="submit">Save</Button>
        <Button variant="secondary" onClick={() => navigate('/provider')}>Cancel</Button>
      </Form>
    </div>
  );
};

export default AddProvider;
